import { Component, defineComponent } from '@decify/cell-shopify/client';
import { buttonClickEvent, buttonName } from '../Button';
import { QuantitySelector, quantitySelectorChangeEvent, quantitySelectorName, quantitySelectorTagName, } from '../QuantitySelector';
import './CartLineItem.scss';
export const cartLineItemName = 'CartLineItem';
export const cartLineItemTagName = 'cell-component-cart-line-item';
export const cartLineItemChangeQuantityEvent = 'change-quantity';
export const cartLineItemRemoveEvent = 'remove';
export class CartLineItem extends Component {
    classNames = {
        base: 'CartLineItem',
    };
    constructor() {
        super(cartLineItemName);
        this.validateProps(['key']);
        this.handleQuantitySelectorChange = this.handleQuantitySelectorChange.bind(this);
        this.handleRemoveButtonClick = this.handleRemoveButtonClick.bind(this);
    }
    componentDidMount() {
        this.subscribe(`${quantitySelectorName}.${quantitySelectorChangeEvent}`, this.handleQuantitySelectorChange);
        this.subscribe(`${buttonName}[remove].${buttonClickEvent}`, this.handleRemoveButtonClick);
    }
    handleQuantitySelectorChange(data) {
        this.resetError();
        this.setLoading(true);
        this.publish(cartLineItemChangeQuantityEvent, {
            key: this.props.key,
            quantity: data.quantity,
        });
    }
    handleRemoveButtonClick() {
        this.resetError();
        this.setLoading(true);
        this.publish(cartLineItemRemoveEvent, { key: this.props.key });
    }
    resetQuantity() {
        this.quantitySelectorElement.reset();
    }
    setLoading(loading) {
        this.classList.toggle(`${this.classNames.base}--Loading`, loading);
    }
    showError(error) {
        this.errorElement.text.textContent = error;
        this.errorElement.wrapper.removeAttribute('hidden');
    }
    resetError() {
        this.errorElement.text.textContent =
            this.errorElement.wrapper.getAttribute('data-error-template');
        this.errorElement.wrapper.setAttribute('hidden', 'hidden');
    }
    get quantitySelectorElement() {
        const quantitySelectorElement = this.querySelector(quantitySelectorTagName);
        if (!quantitySelectorElement || !(quantitySelectorElement instanceof QuantitySelector)) {
            throw new Error('Quantity selector element not found');
        }
        return quantitySelectorElement;
    }
    get errorElement() {
        const wrapperElement = this.querySelector(`.${this.classNames.base}__Error`);
        const textElement = wrapperElement?.children[0];
        if (!wrapperElement || !textElement) {
            throw new Error('Error element not found');
        }
        return {
            wrapper: wrapperElement,
            text: textElement,
        };
    }
}
defineComponent(cartLineItemTagName, CartLineItem);
